import PropTypes from 'prop-types';
import cx from 'classnames';

import { withRouter } from 'core/libs/router';
import withTheme from 'core/hocs/withTheme';

import themePropTypes from 'core/utils/prop-types/theme';

import { resolveScopedStyles } from 'core/utils/styled-jsx';

import Link from 'core/components/Link';


function Logo(props, { host }) {
  const {
    theme,
    className,
    atomsName,
    location: {
      pathname,
    },
    title,
  } = props;

  const {
    controls: {
      [atomsName]: controlAtoms,
      logo: {
        linkHref,
      },
    },
  } = theme;

  const {
    Icon,
    width: logoWidth,
    height: logoHeight,
    marginTop,
  } = controlAtoms.logo;

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .link
          text-decoration none

          &:visited
          &:hover
          &:active
            text-decoration none

          margin-top ${marginTop}
      `}</style>
    </scope>
  );

  return (
    <Link
      to={linkHref}
      onClick={e => {
        if (pathname === linkHref) {
          e.preventDefault();
          window.location.reload();
        }
      }}
      type={(
        /**
         * По рекоммендации от google: Avoid non-composited animations
         * убираем стили ссылки, привязанные к типу.
         */
        'blank'
      )}
      className={cx(className, scope.wrapClassNames('link'))}
      data-qa='lb-logo'
      aria-label='Лого'
      title={title || host.replace('www.', '')}
    >
      <Icon
        {...logoWidth && { width: logoWidth }}
        {...logoHeight && { height: logoHeight }}
      />
      <scope.styles />
    </Link>
  );
}

Logo.defaultProps = {
  atomsName: 'shapka',
};

Logo.propTypes = {
  /** @ignore */
  location: PropTypes.object,
  /** @ignore */
  className: PropTypes.string,
  /**
   * Имя стилевых атомов, которые будут применены к логотипу
   */
  atomsName: PropTypes.oneOf(['shapka', 'scooter']),
  /** @ignore */
  theme: themePropTypes(`{
    controls: {
      logo: {
        linkHref,
      }
      shapka: {
        logo: {
          Icon,
          marginTop,
        },
      },
      scooter: {
        logo: {
          Icon,
          marginTop,
        },
      }
    }
  }`),
  /** Атрибут title, контент всплывающей подсказки */
  title: PropTypes.string,
};

Logo.contextTypes = {
  host: PropTypes.string,
};

const LogoWithHOCs = withRouter(withTheme(Logo));
LogoWithHOCs.displayName = 'Logo';

export { Logo as StorybookComponent };
export default LogoWithHOCs;
